import { Link, useNavigate } from "react-router-dom";
// Hooks
import { useAuthContext } from "../../hooks/useAuthContext";
import { useFirestore } from "../../hooks/useFirestore";
// Components
import ProjectForm from "./components/ProjectForm";
// Styles
import "../../styles/pages/ProjectEditor.css";

const CreateProject = () => {
  // Firestore method and request state for creating projects
  const { addDocument, response } = useFirestore("projects");
  // Get the currently authenticated user
  const { user } = useAuthContext();
  // Used to navigate to the new project after creation
  const navigate = useNavigate();

  // Create the project in Firestore
  const handleSubmit = async (formData) => {
    if (response.isPending) return;

    const newProject = {
      ...formData,
      createdBy: user.uid,
    };

    // Add the new project document to Firestore
    const docRef = await addDocument(newProject);
    // Navigate to the newly created project
    if (docRef?.id) navigate(`/projects/${docRef.id}`, { replace: true });
  };

  return (
    <main className="project-editor-page position-relative overflow-hidden">
      {/* Subtle background grid */}
      <div
        className="project-editor-grid position-absolute top-0 start-0 w-100 h-100"
        aria-hidden="true"
      />
      {/* Decorative background text */}
      <div
        className="project-editor-background-text position-absolute user-select-none"
        aria-hidden="true"
      >
        CREATE
      </div>
      <div className="container position-relative z-1">
        {/* Back to projects */}
        <Link
          to="/projects"
          className="project-editor-back d-inline-flex align-items-center gap-2 text-decoration-none mb-4"
        >
          <i className="bi bi-arrow-left" aria-hidden="true" />
          Back to projects
        </Link>
        {/* Page header */}
        <div className="project-editor-header mb-5">
          <span className="project-editor-eyebrow font-monospace text-danger d-block mb-3">
            PROJECT / CREATE
          </span>
          <h1 className="project-editor-title fw-bold mb-3">Create something new.</h1>
          <p className="project-editor-description text-secondary mb-0">
            Add a project to Benoma and connect the people, technologies and ideas behind it.
          </p>
        </div>
        {/* Project form */}
        <ProjectForm
          onSubmit={handleSubmit}
          isPending={response.isPending}
          error={response.error}
          success={response.success}
          submitLabel="Create Project"
        />
      </div>
    </main>
  );
};

export default CreateProject;
